import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { B2bInvoiceFilterBody } from '../../../shared/models/b2b-filter-invoice.model';
import { ActivatedRoute } from '@angular/router';
import { DialogService } from '@ui/dialog-v2/dialog.service';
import { LocalDateAdapter } from '@core/localization/local-date-adapter';
import {
    ChangeInvoiceStatusDialogComponent,
} from './change-invoice-status-dialog/change-invoice-status-dialog.component';
import { InvoiceFormComponent } from './invoice-form/invoice-form.component';
import { TableB2bInvoicesComponent } from './table-b2b-invoices/table-b2b-invoices.component';
import { AsyncPipe } from '@angular/common';
import { PushService } from '@core/push/push.service';
import { PushCodeModel } from '@core/push/push-code.model';
import { RoutingQueryParamsName } from '@core/router/routing.params';
import { B2bInvoiceFilterComponent } from './b2b-invoice-filter/b2b-invoice-filter.component';
import { PartnerProgram } from '@api/models/B2bService/Contract/partner-program';
import { B2bProgramType } from '../../../shared/models/b2b-program-type';
import { B2bProgramInvoicesState } from '../../../shared/state/b2b-program-invoices.state';
import { ListB2BInvoiceResponse } from '@api/models/B2bService/Contract/Invoice/list-b-2-b-invoice-response';
import {
    ListB2BInvoiceStatusResponse,
} from '@api/models/B2bService/Contract/Invoice/list-b-2-b-invoice-status-response';
import { getLoadingProp } from '@core/state/operators/start-with-loading';
import { StartWithUnit } from '@core/state/operators/start-with-unit';
import { AbstractGridHandlers } from '@ui/base/abstract-grid/abstract-grid.component';
import { RxEffects } from '@rx-angular/state/effects';
import { AddB2BInvoiceRequest } from '@api/models/B2bService/Contract/Invoice/add-b-2-b-invoice-request';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { parseNumber } from '@libs/functions';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
    selector: 'b2b-page-program-invoices',
    templateUrl: './program-invoices.component.html',
    styleUrls: ['./program-invoices.component.scss'],
    imports: [InvoiceFormComponent, TableB2bInvoicesComponent, AsyncPipe, B2bInvoiceFilterComponent, TranslatePipe],
    providers: [RxEffects],
})
export class ProgramInvoicesComponent {
    readonly #push: PushService = inject(PushService);
    readonly #dateFormatService: LocalDateAdapter = inject(LocalDateAdapter);
    readonly #b2bProgramInvoicesState: B2bProgramInvoicesState = inject(B2bProgramInvoicesState);
    readonly #route: ActivatedRoute = inject(ActivatedRoute);
    readonly #dialog: DialogService = inject(DialogService);
    readonly #effects: RxEffects = inject(RxEffects);

    public readonly prgId: number = parseNumber(this.#route.parent?.snapshot.paramMap.get(RoutingQueryParamsName.PrgId));
    public readonly invoices$: Observable<ListB2BInvoiceResponse[]> = this.#b2bProgramInvoicesState.invoices$;

    public readonly pending$: Observable<boolean> = this.#b2bProgramInvoicesState.loading$.pipe(
        getLoadingProp(StartWithUnit.RequestB2BProgramInvoices),
    );

    public readonly pendingCreateInvoice$: Observable<boolean> = this.#b2bProgramInvoicesState.loading$.pipe(
        getLoadingProp(StartWithUnit.CreateB2BProgramInvoice),
    );

    public readonly statuses$: Observable<ListB2BInvoiceStatusResponse[]> = this.#b2bProgramInvoicesState.statuses$;

    public readonly dateFormat: string = this.#dateFormatService.format.angularDate;
    public readonly b2bProgramType: typeof B2bProgramType = B2bProgramType;

    public isEditUser$: Observable<boolean>;
    public b2bProgram: PartnerProgram;

    public readonly handlersGrid: AbstractGridHandlers = {
        handlerDeleteEntity: this.deleteInvoice.bind(this),
    };

    public applyFilterInvoices(body: B2bInvoiceFilterBody): void {
        this.#b2bProgramInvoicesState.requestInvoices(body);
    }

    public createInvoice(body: AddB2BInvoiceRequest): void {
        this.#effects.register(this.#b2bProgramInvoicesState.createInvoice(body), () => this.#push.success(PushCodeModel.SuccessAdd));
    }

    public deleteInvoice(invoice: ListB2BInvoiceResponse): void {
        this.#dialog.openConfirmPopup(
            this.#b2bProgramInvoicesState.deleteInvoice.bind(this.#b2bProgramInvoicesState, invoice.invId),
            this.#b2bProgramInvoicesState.loading$.pipe(getLoadingProp(StartWithUnit.DeleteB2BProgramInvoice)),
        );
    }

    public openChangeStatusDialog(invoice: ListB2BInvoiceResponse): void {
        this.#dialog.openDialog(ChangeInvoiceStatusDialogComponent, {
            title: marker('global.labels.changeStatus'),
            serviceParams: {
                invId: invoice.invId,
                stCode: invoice.stCode,
            },
        });
    }
}
